import React from "react";
import "../../../styles/SimpleQuizz/ZoneReponses/ButtonsNextPrevious.css";
export const ButtonsNextPrevious = ({
  questionId,
  setQuestionId,
  numberOfQuestions,
}) => {
  return (
    <div className="container_quiz_options">
      <button
        className="button precedent"
        disabled={questionId === 0}
        onClick={() => {
          setQuestionId(questionId - 1);
        }}
      >
        Question Précédente
      </button>

      <button
        className="button suivant"
        disabled={questionId === numberOfQuestions - 1}
        onClick={() => {
          setQuestionId(questionId + 1);
        }}
      >
        Question Suivante
      </button>
    </div>
  );
};
